import moment from "moment";

export const formatRelativeTime = (date) => {
    if (!date) return "Sin datos";

    const target = moment(date);
    if (!target.isValid()) return "Sin datos";

    const now = moment();
    const diffMinutes = now.diff(target, "minutes");

    if (diffMinutes < 1) return `${now.diff(target, "seconds")}s`;
    if (diffMinutes < 60) return `${diffMinutes} min`;

    const diffHours = now.diff(target, "hours");
    if (diffHours < 24) return `${diffHours} hs`;

    const diffDays = now.diff(target, "days");
    return `${diffDays} día${diffDays !== 1 ? "s" : ""}`;
};

export const getTrackingTimestamp = (cadete = {}) => {
    const location = cadete.location || {};
    const tracking = cadete.tracking;

    const trackingCandidates = [];
    if (tracking && typeof tracking === "object") {
        if (!Array.isArray(tracking) && tracking.created_at) {
            trackingCandidates.push(tracking.created_at);
        }
        if (Array.isArray(tracking)) {
            tracking.forEach((item) => {
                if (item?.created_at) trackingCandidates.push(item.created_at);
            });
        }
    }

    const candidates = [
        ...trackingCandidates,
        cadete.last_tracking_at,
        cadete.lastTrackingAt,
        cadete.updated_at,
        cadete.updatedAt,
        location.created_at,
        location.timestamp,
        location.fecha,
        location.fecha_hora,
        location.updated_at,
        location.updatedAt,
        location.time
    ];

    const value = candidates.find((candidate) => candidate);
    if (!value) return null;

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};
